import { render, staticRenderFns } from "./public-header.vue?vue&type=template&id=624a8c66&scoped=true&"
import script from "./public-header.vue?vue&type=script&lang=js&"
export * from "./public-header.vue?vue&type=script&lang=js&"
import style0 from "./public-header.vue?vue&type=style&index=0&id=624a8c66&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "624a8c66",
  null
  
)

export default component.exports